// @flow

import React from 'react';
import styler from 'react-styling';
import ReactTooltip from 'react-tooltip';
import radium from 'radium';
import breakpoints from '../../../css/breakpoints';

const style = styler `
  AddEventBtn
    position: absolute
    right: 40px
    bottom: 105px
    z-index: 100
    height: 90px
    width: 90px
    border-radius: 100px
    background: #497BEB
    box-shadow: 5px 5px 30px rgba(0,0,0,0.2)
    border: 0
    @media screen and (max-width: ${breakpoints.MEDIUM_AND_BELOW}px)
      right: 35px
      bottom: 85px
    @media screen and (max-width: ${breakpoints.SMALL_AND_BELOW}px)
      width: 60px
      height: 60px
      right: 20px
      bottom: 70px
  Plus
    fill: #FFF
    width: 40px
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    cursor: pointer
    @media screen and (max-width: ${breakpoints.SMALL_AND_BELOW}px)
      width: 30px
`;

export const CreateEventBtn = (props: { handlerFunc: Function, tipText: string }) => (
  <div>
    <button
      style={style.AddEventBtn} onClick={props.handlerFunc}
      data-tip={props.tipText}
    >
      <svg style={style.Plus} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 230 230">
        <path
          className="st0" d="M218,103h-91V12c0-6.6-5.4-12-12-12s-12,5.4-12,12v91H12c-6.6,0-12,5.4-12,12c0,6.6,5.4,12,12,12h91v91c0,6.6,5.4,12,12,12s12-5.4,12-12v-91h91c6.6,0,12-5.4,12-12C230,108.4,224.6,103,218,103z"
        />
      </svg>
    </button>
    <ReactTooltip />
  </div>
);

export default radium(CreateEventBtn);



// WEBPACK FOOTER //
// ./src/js/Components/Elements/CreateEventBtn.js